import { Box, Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  bar: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    justifyContent: 'center',
    zIndex: 10,
  },
  inner: {
    width: '100%',
    maxWidth: 480,
  },
  button: {
    height: 48,
    fontWeight: 'bold',
  },
}));

export function SubmitFooter({ onSubmit, submitting, disabled }) {
  const classes = useStyles();

  return (
    <Box className={classes.bar}>
      <Box className={classes.inner}>
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          fullWidth
          onClick={onSubmit}
          disabled={submitting || disabled}
          startIcon={submitting ? <CircularProgress size={18} color="inherit" /> : null}
        >
          Salvar Resultados
        </Button>
      </Box>
    </Box>
  );
}
